<div>
  <div class="v4-layout-form v4-layout-form-vertical" [formGroup]="form">
    <div class="v4-layout-field">
      <div
        class="v4-layout-field-label"
        [innerHTML]="
          'automation-edit_price_html_价格调整'
            | translate
              : {
                  property: detail?.property,
                  date: (detail?.plan_time | dateformat: ['MD'])
                }
        ">
        <!-- The price of <span class="text-c-d1 font-medium">{{ detail?.property }}</span> on
        {{ detail?.plan_time | date : ["YM"] }} will be adjusted at -->
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <div class="w-1/2 pr-2">
            <nz-date-picker
              formControlName="plan_date"
              class="w-full"
              nzSize="large"
              [nzFormat]="angularDateFormat"></nz-date-picker>
          </div>
          <div class="w-1/2 pl-2">
            <nz-time-picker
              formControlName="plan_time"
              class="w-full"
              nzSize="large"
              [nzFormat]="timeFormat"></nz-time-picker>
          </div>
        </div>
      </div>
    </div>

    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        {{ "automation-edit_price_html_价格调整为" | translate: { percent: detail?.to_percent } }}
        <!-- The price will be adjusted from {{ detail?.to_percent }}% to -->
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <nz-input-number
            class="w-full"
            [nzFormatter]="formatterPercent"
            formControlName="to_percent"
            nzSize="large"
            [nzPlaceHolder]="'Percent'"></nz-input-number>
          <!-- <host-select
            class="w-full"
            size="large"
            formControlName="assigned_person"
            placeholder="Select a member (optional)"
            [defaultValue]="null"
            [listOfOption]="optionsOfAssigner"
          ></host-select> -->
          <!-- <textarea formControlName="content" nz-input rows="4"></textarea> -->
        </div>
        <!-- <div class="v4-layout-field-extra">
          <div class="w-[150px]">
            <host-quick-msg-picker (onSelect)="onSelectQuickMsg($event)"></host-quick-msg-picker>
          </div>
        </div> -->
      </div>
    </div>
  </div>

  <div class="footer flex flex-row items-center justify-between">
    <div>
      <a nz-button nzType="link" nzDanger (click)="onRemove()">
        {{ "automation-edit_message_html_移除" | translate }}
        <!-- Remove -->
      </a>
      <a class="ml-2" nz-button nzType="link" (click)="onClickEdit()">{{
        "automation-edit_message_html_编辑规则" | translate
      }}</a>
    </div>
    <div class="ml-auto">
      <button class="mr-3" nz-button nzSize="large" (click)="onExecuteImmediately()">
        {{ "automation-edit_price_html_立即调整" | translate }}
        <!-- Adjust now -->
      </button>
      <button nz-button nzType="primary" nzSize="large" (click)="onSave()">
        {{ "word.save" | translate }}
        <!-- Save -->
      </button>
    </div>
  </div>
</div>
